<agr-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirmFertilizerImport()"
  (cancel)="cancel()"
  #ngForm="ngForm"
>
  <div class="dialog spacing--margin-top">
    <h1>{{ 'importMineralBalance' | translate }}</h1>
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto" data-test="edit-fertilizer-import-from">
        <mat-label>{{ 'from' | translate }}</mat-label>
        <input
          matInput
          formControlName="deliveriesFrom"
          [matDatepicker]="fromDatePicker"
          [placeholder]="'from' | translate"
        />
        <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" data-test="edit-fertilizer-import-until">
        <mat-label>{{ 'until' | translate }}</mat-label>
        <input
          matInput
          formControlName="deliveriesUntil"
          [matDatepicker]="untilDatePicker"
          [placeholder]="'until' | translate"
        />
        <mat-datepicker-toggle matSuffix [for]="untilDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #untilDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</agr-dialog>
